import { render, staticRenderFns } from "./StudentAddressLookup.vue?vue&type=template&id=1ba60ca8&scoped=true&"
import script from "./StudentAddressLookup.vue?vue&type=script&lang=js&"
export * from "./StudentAddressLookup.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddressLookup.vue?vue&type=style&index=0&id=1ba60ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba60ca8",
  null
  
)

export default component.exports